import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { mapFeatureToPlatforms, mapToApiPlatform } from 'utils';

const mapPlatformToPermission = mapToApiPlatform;

export default function usePlatform() {
  const platforms = useSelector(
    (state) =>
      state.accountReducer.currentUser?.user?.permissions?.SearchPlatforms
  );
  const settingsDefaultPlatform = useSelector(
    (state) =>
      state.settingsReducer.filters?.public?.defaultPlatformSelectBox
        ?.selectedValue
  );

  const memoizedPlatformToPermission = useMemo(
    () => mapPlatformToPermission,
    []
  );

  const meomizedFeatureToPlatforms = useMemo(() => mapFeatureToPlatforms, []);

  const hasPermission = useCallback(
    (platform) => {
      return Boolean(
        platforms?.[memoizedPlatformToPermission[platform]]?.permission
      );
    },
    [memoizedPlatformToPermission, platforms]
  );

  const getPlatforms = useCallback(
    (feature = 'contents', includePermission = true) => {
      if (!includePermission) return meomizedFeatureToPlatforms[feature];
      return meomizedFeatureToPlatforms[feature].filter((platform) =>
        hasPermission(platform)
      );
    },
    [hasPermission, meomizedFeatureToPlatforms]
  );

  const getDefaultPlatform = useCallback(
    (feature) => {
      return getPlatforms(feature).find((platform) => hasPermission(platform));
    },
    [getPlatforms, hasPermission]
  );

  const getSettingsDefaultPlatform = useCallback(
    (feature) => {
      return hasPermission(settingsDefaultPlatform) &&
        getPlatforms(feature).includes(settingsDefaultPlatform)
        ? settingsDefaultPlatform
        : getDefaultPlatform(feature);
    },
    [getDefaultPlatform, getPlatforms, hasPermission, settingsDefaultPlatform]
  );

  return {
    getPlatforms,
    getDefaultPlatform,
    getSettingsDefaultPlatform,
    hasPermission,
  };
}
